import { createNotification } from "react-redux-notify";
import { select, put, takeLatest, all } from "redux-saga/effects";

import api from "../../Environment";
import {
  updatePostComments,
  updatePostCommentsCount,
} from "../actions/HomeAction";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from "../../components/helper/NotificationMessage";
import {
  SAVE_COMMENT_START,
  DELETE_COMMENT_START,
  FETCH_COMMENTS_START,
} from "../actions/ActionConstant";
import {
  updateOtherUserPostComments,
  updateOtherUserPostCommentsCount,
} from "../actions/OtherUserAction";
import {
  saveCommentFailure,
  saveCommentSuccess,
  deleteCommentFailure,
  deleteCommentSuccess,
  fetchCommentsFailure,
  fetchCommentsSuccess,
} from "../actions/CommentsAction";
import ErrorUtils from "../../helpers/utils/errors";
import { updateSinglePostComments, updateSinglePostCommentsCount } from "../actions/PostAction";
import { updateUserPostComments } from "../../store/actions/PostAction";
import { updateUserPostCommentsCount } from "../../store/actions/PostAction";
import { showErrorComponent } from "../actions/ComponentAction";

function* fetchCommentsAPI() {
  try {
    const inputData = yield select((state) => state.comment.comments.inputData);
    
    // Prepare API payload for cursor-based pagination
    const apiPayload = {
      post_id: inputData.post_id
    };
    
    // Add cursor if provided (for pagination)
    if (inputData.cursor) {
      apiPayload.cursor = inputData.cursor;
    }
    
    const response = yield api.postMethod("post_comments", apiPayload);
    if (response.data.success) {
      yield put(fetchCommentsSuccess(response.data.data));
    } else {
      yield put(fetchCommentsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchCommentsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* saveCommentAPI(action) {
  try {
    const inputData = yield select(
      (state) => state.comment.saveComment.inputData
    );

    const response = yield api.postMethod("post_comments_save", inputData);
    if (response.data.success) {
      yield put(saveCommentSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );

      yield put(updateUserPostCommentsCount(inputData));
      yield put(updateUserPostComments(response.data.data));

      yield put(updatePostCommentsCount(inputData));
      // Removed updatePostComments since we handle it in CommentsReducer via USER_POST_COMMENTS

      yield put(updateOtherUserPostCommentsCount(inputData));
      yield put(updateOtherUserPostComments(response.data.data));

      const { data } = action;
      if (data && data.payload) {
        const { type, id } = data.payload;
        if (type === "singlePost") {
          yield put(updateSinglePostCommentsCount(response.data.data))
          yield put(updatePostComments(response.data.data))
        }
      }

      yield put(createNotification(notificationMessage));
    } else {
      yield put(saveCommentFailure(response.data.error));
      const { notify, message } = ErrorUtils.handleApiError(response.data)
      if (notify) {
        yield put(createNotification(getErrorNotificationMessage(message)));
      }
    }
  } catch (error) {
    yield put(saveCommentFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* deleteCommentAPI() {
  try {
    const inputData = yield select((state) => state.docs.delDocs.inputData);
    const response = yield api.postMethod("documents_delete", inputData);
    if (response.data.success) {
      yield put(deleteCommentSuccess(response.data.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(deleteCommentFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(deleteCommentFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_COMMENTS_START, fetchCommentsAPI)]);
  yield all([yield takeLatest(SAVE_COMMENT_START, saveCommentAPI)]);
  yield all([yield takeLatest(DELETE_COMMENT_START, deleteCommentAPI)]);
}
